import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Retry on a failed text bubble (2026-09-15). The bubble partial is
// re-broadcast from the worker whenever delivery status changes, and a
// button_to rendered there carried a CSRF token no browser session could
// use, so Retry answered 422 and the error page's Try again 404'd. This
// posts with the page's LIVE token at click time and renders the
// turbo_stream reply (the bubble flips to "Sending"). On any failure the
// button stays usable and says so; nothing navigates away.
export default class extends Controller {
  static values = { url: String }

  async retry(event) {
    event.preventDefault()
    const button = event.currentTarget
    if (button.disabled) return
    button.disabled = true
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: { "X-CSRF-Token": token || "", Accept: "text/vnd.turbo-stream.html" }
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      Turbo.renderStreamMessage(await res.text())
    } catch (e) {
      button.disabled = false
      button.textContent = "Retry did not go through, tap again"
    }
  }
}
